// src/components/CanopyConnect.js
import React, { useEffect, useState, useRef } from "react";
import { useWebSocket } from "../hooks/CanopyWebSocket";
import SockJsClient from "react-stomp";
import { DEFAULT_URL } from "../lib/ApiConfig";
const CanopyConnect = ({ onComplete, onBack, userData }) => {
  const [authError, setAuthError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState({ id: "CUST_K7dDa9ye4Gxc" }); // Mock customer ID for testing
  const [canopyHandler, setCanopyHandler] = useState(null);
  const initialized = useRef(false);
  const [topics, setTopics] = useState([]);
  const canopyHandlerRef = useRef(null);

  const { lastMessage, renderWebSocketClient } = useWebSocket(
    "http://localhost:8082/policies-available",
    "/topic/policies-available"
  );

  // Initialize as soon as component loads for testing
  useEffect(() => {
    console.log("INIT CANOPY");
    if (initialized.current) return;
    initialized.current = true;
    console.log("initializing");
    setLoading(false);
    window.doneWithSuccess = function () {
      console.log("Connection successful! Redirecting to success screen...");
      if (onComplete) {
        onComplete();
      }
    };
    window.doneWithError = function () {
      console.log("Connection failed.");
      alert("Connection failed. Please try again.");
    };

    if (!userData || !userData.id || !window.CanopyConnect) return;
    if (canopyHandler !== null) return;
    const handler = window.CanopyConnect.create({
      publicAlias: "ownli0",
      modal: true,
      pullMetaData: { customer: userData.id },
      onAuthenticationSuccess: () => {
        console.log("Authentication successful");
      },
      onSelectCustomInsuranceProvider: () => {
        console.log("Provider selected");
      },
      onExit: (data) => {
        console.log("handler", handler);
        console.log("canopyHandler", canopyHandler);
        const currentHandler = canopyHandlerRef.current;

        if (currentHandler) {
          try {
            currentHandler.close();
            currentHandler.onDestroy();
            console.log("Canopy closed");
          } catch (e) {
            //console.error("Error closing Canopy:", e);
          }
        }
        if (data && data.err) {
          console.log("Error:", data.err);
          window.doneWithError();
        } else {
          onBack();
        }
      },
      onDestroy: () => {
        console.log("Canopy widget destroyed");
        const container = document.getElementById("canopy-container");
        if (container) container.innerHTML = "";
      },
    });

    setCanopyHandler(handler);
    canopyHandlerRef.current = handler;

    if (customer && customer.id && handler) {
      console.log("Canopy handler:", handler);
      const mount = () => {
        const container = document.getElementById("canopy-container");
        if (container) {
          console.log("Mounting Canopy to container");
          handler.open(container);
        } else {
          console.error("Canopy container not found");
        }
      };

      // Small delay to ensure DOM is ready
      setTimeout(mount, 100);
    }
    // Auto-open Canopy
    // setTimeout(() => {
    //   const container = document.getElementById("canopy-container");
    //   if (container) canopyHandler.open(container);
    // }, 500);

    return () => {
      if (handler) {
        try {
          handler.close();
          handler.onDestroy();
          console.log("Canopy closed");
        } catch (e) {
          console.error("Error closing Canopy:", e);
        }
      }
    };
  }, [customer.id]);

  // Initialize Canopy

  useEffect(() => {}, [canopyHandler, customer]);

  // Process WebSocket messages
  useEffect(() => {
    if (lastMessage && customer.id) {
      console.log("Processing WebSocket message:", lastMessage);
      if (lastMessage.customerId === customer.id) {
        if (lastMessage.pullId && !lastMessage.errorCode) {
          console.log("Pull successful, proceeding to next step");
          window.doneWithSuccess();
        } else {
          console.log("Pull error");
          window.doneWithError();
        }
      }
    }
  }, [lastMessage, customer]);

  if (loading)
    return <div className="p-4 text-center">Loading Canopy Connect...</div>;
  if (authError)
    return (
      <div className="p-4 text-center text-red-600">
        Authentication error. Please try again.
      </div>
    );

  return (
    <div className="space-y-4">
      <SockJsClient
        url={`${DEFAULT_URL}/policies-available/`}
        topics={topics}
        onConnect={() => {
          console.log("connected");
          //topics={["/topic/policies-available"]}
          setTopics(["/topic/policies-available"]);
        }}
        onDisconnect={() => {
          console.log("Disconnected");
        }}
        onMessage={(msg) => {
          console.log(msg);
          if (
            msg &&
            msg.pullId &&
            msg.customerId &&
            msg.customerId == customer.id
          ) {
            window.doneWithSuccess();
          } else if (msg && msg.customerId && msg.customerId == customer.id) {
            window.doneWithError();
          } else {
            //do nothing - this message is not for you.
          }
        }}
        ref={(client) => {
          console.log(client);
        }}
      />
      <div id="canopy-container" style={{ minHeight: "400px" }}></div>
    </div>
  );
};

export default CanopyConnect;
